import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Supprimer les erreurs ResizeObserver loop (erreur bénigne de développement)
const resizeObserverLoopErrRe = /^[^(ResizeObserver loop)]*/
const errorHandler = (event) => {
  if (resizeObserverLoopErrRe.test(event.message)) {
    const isResizeObserverError = event.message.includes('ResizeObserver loop');
    if (isResizeObserverError) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return;
    }
  }
}
window.addEventListener('error', errorHandler);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
